import { useEffect } from "react";

export function usePageTitle(title: string) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title + " | Lumen@home";
    return () => {
      document.title = prevTitle;
    };
  });
}

export default usePageTitle;
